import React, { useEffect, useState } from 'react'
import { InputAdornment, TextField } from '@mui/material';
import { checkUsability, checkDefineNthPurchase, checkActivePeriod, checkActiveTime, isOnlyDateUpdate } from "../../../services/services"
import CouponBox from '../../CouponBox';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import DefineNthPurchase from './DefineNthPurchase';
import Usability from './Usability';
import CalendarToggle from './CalendarToggle';
import SkipThisStep from './SkipThisStep';
import { isOnlyDigit } from '../../../services/services';
import { updateCouponLife,updateCouponLifeSkip } from '../../../../../stateManagement/actions/manageCouponActions';
import DateTimeSelector from './DateTimeSelector';
import { useSelector } from 'react-redux';
import { labelMappings } from '../../../utils/utils';
import store from "../../../../../../src/stateManagement/store";
import { UsabilityLimitsProps } from '../../../types';
import PercentUsabilityLimit from '../usabilityLimits/PercentUsabilityLimit';
import CouponTimings from './CouponTimings/CouponTimings';
import DeleteParentCoupon from '../usabilityLimits/DeleteParentCoupon';
import { useNavigate } from 'react-router-dom';

function Recurrence({ setDateChanged }: UsabilityLimitsProps) {
    const { recurrence,couponEditType,couponTypeOption } = store.getState()?.manageCoupons?.data;
    const { iniCouponLife,couponLife } = useSelector((state: any) => state?.manageCoupons?.data?.recurrence);
    const [coupLife, setCouponLife] = useState(couponLife);
    const [errorText, setErrorText] = useState("");
    const [skipCouponLife, setSkipCouponLife] = useState(useSelector((state: any) => Boolean(state?.manageCoupons?.data?.recurrence?.skipCouponLife) || false));
    
    
    const navigate = useNavigate();
    let {usabilityLimit, usability}=recurrence;

    const handleCouponLifeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.trim().replace(/^0+/, '')
        if (isOnlyDigit(value)) {
            setCouponLife(value);
            updateCouponLife(value);
            setErrorText(value.trim() === "" ? 'This field cannot be empty' : "");
        }
    }
    const handleSkipCouponLife = () => {

        if (couponEditType === "edit") {
            if (skipCouponLife) {
                setSkipCouponLife(false);
                updateCouponLifeSkip(false);
                updateCouponLife(iniCouponLife);
                setCouponLife(iniCouponLife);
                setErrorText("");
            }
            else {
                setSkipCouponLife(true);
                updateCouponLifeSkip(true);
                setErrorText("");
                updateCouponLife(null);
                setCouponLife(null);
            }
        } else {
            if (skipCouponLife) {
                setSkipCouponLife(false);
                setErrorText("");
            }
            else {
                setSkipCouponLife(true);
                setErrorText("");
                updateCouponLife("");
                setCouponLife("");
            }
        }
    };

    
    return (
        <div className='usability-limits-wrapper'>
            <div className="recurrence-coupon-box">
                <DateTimeSelector setDateChanged={setDateChanged} />
            </div>     
            <div className='recurrect-items' style={{position:'relative'}}>
                {couponTypeOption!=='total_order_welcome' ? (
                    <div className={`${isOnlyDateUpdate() && couponEditType === "edit" ? 'recurrence-blurred-uneditable' : ''}`}>
                        <div className={`${skipCouponLife ? "" : "textFieldOutline"}`}
                            style={{
                            backgroundColor: skipCouponLife ? '#f7f7f7' : "#f3fcfb",
                            display: 'flex',
                            alignItems: "center",
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            borderColor: skipCouponLife ? 'white' : "lightgray"
                        }}>
                            <div style={{
                                display: "flex", alignItems: "center", height: "100%", borderRadius: "5px",
                                padding: "0px 20px 0px 20px"
                            }}>
                                <p style={{
                                    whiteSpace: "nowrap", gap: "10",
                                    fontSize: '16px', alignItems: "center", justifyContent: "center", color: skipCouponLife ? "#a8a8a8" : "#24c6b1", fontWeight: "bold"
                                }}>{labelMappings["coupon-life"]}</p>
                            </div>
                                <div className={"coupon-box-wrapper-border"} style={{ border: 'white 10px solid', width: "95%", borderRadius: "5px" }}>
                                    <TextField
                                        id="outlined-basic"
                                        placeholder={labelMappings["recurrence-coupon-life-placeholder"]}
                                        variant="outlined"
                                        size="small"
                                        value={coupLife}
                                        onChange={handleCouponLifeChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <SkipThisStep onClick={handleSkipCouponLife} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={errorText !== ""}
                                        helperText={errorText}
                                        disabled={skipCouponLife}
                                    />
                                </div> 
                            </div>
                        </div> 
            ) : null}

                {checkActivePeriod() ? <div className={''}><div className="recurrence-coupon-box">
                    <CalendarToggle />
                </div></div> : null}
                {checkDefineNthPurchase() && couponTypeOption!=='total_order_welcome'  ? <div className={`${couponEditType === "edit" ? 'recurrence-blurred-uneditable' : ''}`}><div className="recurrence-coupon-box">
                    <DefineNthPurchase />
                </div></div> : null}
                {checkUsability() && couponTypeOption!=='total_order_welcome'   ? <div className={`${couponEditType === "edit" && false ? 'recurrence-blurred-uneditable' : ''}`}><div className="recurrence-coupon-box">
                    <Usability />
                </div></div> : null}

            </div>
            <PercentUsabilityLimit />
            {
                checkActiveTime() && <div className={`${couponEditType === "edit" ? 'recurrence-blurred-uneditable' : ''}`}><CouponTimings/></div>
            }
            <DeleteParentCoupon/>
        </div>
    )
}

export default React.memo(Recurrence)